'use es6';

import { createClient } from 'laboratory-lib';
import { useState, useEffect } from 'react';
import PortalIdParser from 'PortalIdParser';
const ACADEMY_TREATMENT_KEY = 'ads-017';
const ACADEMY_GROUP_PARAMETER_KEY = 'group';
const ACADEMY_GROUP_PARAMETER_OPTIONS = {
  CONTROL: 'control',
  VARIANT: 'variant'
};
const TREATMENTS_SCHEMA = {
  [ACADEMY_TREATMENT_KEY]: {
    identifier: PortalIdParser.get() || 'unknown',
    parameters: {
      [ACADEMY_GROUP_PARAMETER_KEY]: Object.values(ACADEMY_GROUP_PARAMETER_OPTIONS)
    }
  }
};
const treatmentsClient = createClient({
  quickFetchLabel: 'academy-treatments',
  treatments: TREATMENTS_SCHEMA
});
export const useTreatment = () => {
  const [inVariant, setInVariant] = useState(false);
  useEffect(() => {
    treatmentsClient.resolve(treatments => {
      setInVariant(treatments[ACADEMY_TREATMENT_KEY]['parameters']['group'] === 'variant');
    });
  }, []);
  return inVariant;
};